import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HomeComponent {
    readonly steps = [
        {
            title: 'Fill out an application',
            body: 'You’ll enter your contact details, access dates, location, and why you’re visiting.',
        },
        {
            title: 'Assessment',
            body: 'A staff member will review your application.',
        },
        {
            title: 'Permit application outcome',
            body: 'You will be notified of the decision.',
        },
    ];
}
